import {
	Box,
	IconButton,
	Input,
	InputGroup,
	type InputGroupProps,
	type InputProps,
} from '@chakra-ui/react';
import type React from 'react';
import { useState } from 'react';
import { IoClose, IoSearch } from 'react-icons/io5';
import FaceliftIconButton from '../FaceliftIconButton';

export interface SearchInputProps extends Omit<InputProps, 'onChange'> {
	value?: string;
	placeholder?: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	sx?: React.CSSProperties;
	inputProps?: InputProps;
	startElementProps?: InputGroupProps['startElementProps'];
	showClear?: boolean;
	onClear?: () => void;
}

export const SearchInput: React.FC<SearchInputProps> = ({
	value: controlledValue,
	onChange,
	sx,
	inputProps,
	startElementProps,
	showClear = true,
	onClear,
	placeholder,
	...rest
}) => {
	const [uncontrolledValue, setUncontrolledValue] = useState('');
	const value =
		controlledValue !== undefined ? controlledValue : uncontrolledValue;

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (controlledValue === undefined) setUncontrolledValue(e.target.value);
		onChange?.(e);
	};

	const handleClear = () => {
		if (controlledValue === undefined) setUncontrolledValue('');
		onClear?.();
	};

	return (
		<Box style={sx}>
			<InputGroup
				startElement={<IoSearch />}
				endElement={
					showClear &&
					value && (
						<FaceliftIconButton
							bg="transparent"
							variant="ghost"
							aria-label="Clear"
							color={{ _dark: 'gray.100', _light: 'gray.600' }}
							_hover={{
								color: { _dark: 'brand.black', _light: 'brand.solid' },
								bg: { _dark: 'gray.700', _light: 'gray.300' },
							}}
							size="xs"
							borderRadius={'full'}
							onClick={handleClear}
						>
							<IoClose />
						</FaceliftIconButton>
					)
				}
				startElementProps={{
					...startElementProps,
				}}
			>
				<Input
					borderColor={{ _dark: 'brand.white', _light: '' }}
					_focus={{
						borderColor: 'brand.solid',
					}}
					_placeholder={{
						color: { _dark: 'brand.white', _light: '' },
					}}
					placeholder={placeholder || "Search"}
					value={value}
					onChange={handleChange}
					borderRadius="full"
					{...inputProps}
					{...rest}
				/>
			</InputGroup>
		</Box>
	);
};

export default SearchInput;
